import { Col, Form, Input } from "antd";

const EbCollectionChargeFilterFields = () => {
  return (
    <>
      <Col span={6}>
        <Form.Item label="Bank Reference Number" name="bank_reference_number">
          <Input
            size="small"
            placeholder="Filter by Bank Reference Number"
            allowClear
          />
        </Form.Item>
      </Col>
    </>
  );
};

export default EbCollectionChargeFilterFields;
